import axios from 'axios';

const RUNTIME = Object.freeze({
   development: 'development',
   production: 'production'
});

const env = {
   runtime: process.env.NODE_ENV === 'production' ? RUNTIME.production : RUNTIME.development,
   api_insecure: '',
   api_secure: '',
   captcha: '',
   sentry: ''
};

export const fetchEnvironment = () => {
   if (process.env.NODE_ENV === 'production') {
      return axios.get('/static/js/config/config.json');
   } else {
      return Promise.resolve({
         data: {
            runtime: RUNTIME.development,
            insecure_endpoint: 'http://api.odyssey.g4studio.local/patientportal-insecure',
            secure_endpoint: 'http://api.odyssey.g4studio.local/patientportal',
            captcha_sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            sentry_dsn: ''
         }
      });
   }
};

export default env;



// WEBPACK FOOTER //
// ./src/utils/environment.js